import React from 'react';
import { usePageSeo } from '../Seo/PageSeo';
import '../Common/PlatformInfo.css'

const EventsInfo = () => {
  usePageSeo({
    title: 'Find your perfect venue',
    description:
      'Discover unique UK venues for workshops, parties, and community events. Enquire in minutes with Occasia.',
    path: '/events-info'
  });

  const handleFindVenueClick = () => {
    window.open('https://tally.so/r/wd44MA', '_blank');
  };

  return (
    <div className="platform-info-page">
      {/* Grow Revenue Section */}
      <section className="grow-revenue-section">
        <div className="container">
          <div className="content">
            <h1>Find the Perfect Space Without the Endless Back-and-Forth</h1>
            <p>
              Occasia makes it easy to discover unique venues, enquire in minutes, and get the support you need to bring your event to life.
            </p>
            <button className="cta-button" onClick={handleFindVenueClick}>
              <span>Find your perfect venue</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 5L12.5 10L7.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
          <div className="illustration">
            <svg width="600" height="600" viewBox="0 0 200 200" fill="none">
              {/* Building */}
              <rect x="60" y="80" width="80" height="100" fill="#F5F5DC" stroke="#000" strokeWidth="2"/>
              <rect x="60" y="80" width="80" height="20" fill="#FFF"/>
              {/* Windows */}
              <rect x="70" y="90" width="15" height="15" fill="#046242"/>
              <rect x="95" y="90" width="15" height="15" fill="#046242"/>
              <rect x="120" y="90" width="15" height="15" fill="#046242"/>
              <rect x="70" y="115" width="15" height="15" fill="#046242"/>
              <rect x="95" y="115" width="15" height="15" fill="#046242"/>
              <rect x="120" y="115" width="15" height="15" fill="#046242"/>
              <rect x="70" y="140" width="15" height="15" fill="#046242"/>
              <rect x="95" y="140" width="15" height="15" fill="#046242"/>
              <rect x="120" y="140" width="15" height="15" fill="#046242"/>
              {/* Door */}
              <rect x="95" y="160" width="10" height="20" fill="#F6C531"/>
              {/* Trees */}
              <path d="M40 160L50 120L60 160" stroke="#000" strokeWidth="1" fill="none"/>
              <path d="M140 160L150 120L160 160" stroke="#000" strokeWidth="1" fill="none"/>
              {/* Yellow circles */}
              <circle cx="45" cy="150" r="8" fill="#F6C531"/>
              <circle cx="155" cy="170" r="5" fill="#F6C531"/>
              {/* Green bushes */}
              <circle cx="50" cy="180" r="6" fill="#046242"/>
              <circle cx="150" cy="185" r="4" fill="#046242"/>
            </svg>

          </div>
        </div>
      </section>

      {/* Choose How You Share Section */}
      <section className="choose-share-section">
        <div className="container">
          <div className="content">
            <h2>Discover unique spaces in the city</h2>
            <p className="intro">You love your space, so you control how you share it.</p>
            <div className="description">
              <p>We believe finding a venue should be <strong> inclusive, stress-free, and empowering.</strong> Occasia
                is here to open up access to underused spaces while supporting local venues. When you book through us,
                you’re not just planning an event — you’re <strong> helping communities thrive.</strong></p>
            </div>
            <button className="cta-button" onClick={handleFindVenueClick}>
              <span>Find your perfect venue</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 5L12.5 10L7.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
          <div className="photo">
            <div className="photo-container">
              {/*<div className="badge">TOP HOST</div>*/}
              <img src="/Event_organiser.jpg" alt="Ben Seidel" className="host-photo"/>
              <p className="caption">Emma Lyss • Hosting since 2016</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Partner Section */}
      <section className="why-partner-section">
        <div className="container">
          <h1>WHY PARTNER WITH OCCASIA</h1>
          <p className="intro">
            Everyone from professional photographers and yoga teachers, to Fortune 500 companies need places to meet, create, and celebrate. Get your space in front of the most people searching for spaces like yours.
          </p>

          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M58.6665 16V22.4534C58.6665 26.6667 55.9998 29.3334 51.7865 29.3334H42.6665V10.6934C42.6665 7.73337 45.0932 5.33337 48.0532 5.33337C50.9599 5.36004 53.6265 6.53337 55.5465 8.45337C57.4665 10.4 58.6665 13.0667 58.6665 16Z"
                      stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round"/>
                  <path
                      d="M5.3335 18.6667V56C5.3335 58.2134 7.8401 59.4667 9.6001 58.1334L14.1602 54.72C15.2268 53.92 16.7202 54.0267 17.6802 54.9867L22.1068 59.44C23.1468 60.48 24.8536 60.48 25.8936 59.44L30.3735 54.96C31.3069 54.0267 32.8002 53.92 33.8402 54.72L38.4002 58.1334C40.1602 59.44 42.6668 58.1867 42.6668 56V10.6667C42.6668 7.73337 45.0668 5.33337 48.0002 5.33337H18.6668H16.0002C8.00016 5.33337 5.3335 10.1067 5.3335 16V18.6667Z"
                      stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round"/>
                  <path d="M16 24H32" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M18 34.6666H30" stroke="white" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </div>
              <h3>Curated for your needs</h3>
              <p>Easily find venues matched to your event's type, size, and style with smart search and enhanced
                filters</p>
            </div>

            <div className="benefit-item">
              <div className="icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M58.6668 32C58.6668 46.72 46.7202 58.6667 32.0002 58.6667C17.2802 58.6667 5.3335 46.72 5.3335 32C5.3335 17.28 17.2802 5.33337 32.0002 5.33337C46.7202 5.33337 58.6668 17.28 58.6668 32Z"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M41.8932 40.4801L33.6265 35.5467C32.1865 34.6934 31.0132 32.6401 31.0132 30.9601V20.0267"
                        stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h3>100% verified and pre-vetted</h3>
              <p>Every venue is thoroughly checked and approved by our team, so you can book with confidence.</p>
            </div>

            <div className="benefit-item">
              <div className="icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M24.4268 28.9866C24.1602 28.9599 23.8402 28.9599 23.5468 28.9866C17.2002 28.7733 12.1602 23.5733 12.1602 17.1733C12.1602 10.6399 17.4402 5.33325 24.0002 5.33325C30.5335 5.33325 35.8402 10.6399 35.8402 17.1733C35.8135 23.5733 30.7735 28.7733 24.4268 28.9866Z"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M43.7602 10.6667C48.9336 10.6667 53.0936 14.8534 53.0936 20.0001C53.0936 25.0401 49.0936 29.1467 44.1069 29.3334C43.8936 29.3067 43.6536 29.3067 43.4136 29.3334"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M11.0934 38.8267C4.64008 43.1467 4.64008 50.1867 11.0934 54.4801C18.4268 59.3867 30.4534 59.3867 37.7868 54.4801C44.2401 50.1601 44.2401 43.1201 37.7868 38.8267C30.4801 33.9467 18.4534 33.9467 11.0934 38.8267Z"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M48.9067 53.3333C50.8267 52.9333 52.6401 52.1599 54.1334 51.0133C58.2934 47.8933 58.2934 42.7466 54.1334 39.6266C52.6667 38.5066 50.8801 37.7599 48.9867 37.3333"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

              </div>
              <h3>Complete transparency</h3>
              <p>Clear pricing, detailed info, and no hidden fees — everything you need to make the right choice.</p>
            </div>

            <div className="benefit-item">
              <div className="icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M58.6665 17.3333H42.6665" stroke="white" stroke-width="3" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16.0002 17.3333H5.3335" stroke="white" stroke-width="3" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M26.6668 26.6667C31.8215 26.6667 36.0002 22.488 36.0002 17.3333C36.0002 12.1787 31.8215 8 26.6668 8C21.5122 8 17.3335 12.1787 17.3335 17.3333C17.3335 22.488 21.5122 26.6667 26.6668 26.6667Z"
                      stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round"/>
                  <path d="M58.6667 46.6667H48" stroke="white" stroke-width="3" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21.3335 46.6667H5.3335" stroke="white" stroke-width="3" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M37.3333 55.9999C42.488 55.9999 46.6667 51.8212 46.6667 46.6666C46.6667 41.5119 42.488 37.3333 37.3333 37.3333C32.1787 37.3333 28 41.5119 28 46.6666C28 51.8212 32.1787 55.9999 37.3333 55.9999Z"
                      stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round"/>
                </svg>


              </div>
              <h3>Save Time</h3>
              <p>Find and book venues in minutes, not days of calling around and visiting the venues</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-section">
        <div className="container">
          <div className="left">
            <h2>How it works</h2>
          </div>
          
          <div className="right">
            <div className="steps">
              <div className="step">
                <div className="number">1</div>
                <div className="content">
                  <h3>Search</h3>
                  <p>Enter your event details (date, size, type) to see tailored results.</p>
                </div>
              </div>

              <div className="step">
                <div className="number">2</div>
                <div className="content">
                  <h3>Explore</h3>
                  <p>Browse venue profiles with photos, pricing, and availability.</p>
                </div>
              </div>

              <div className="step">
                <div className="number">3</div>
                <div className="content">
                  <h3>Select</h3>
                  <p>Choose one or multiple venues and send your enquiry in minutes.</p>
                </div>
              </div>

              <div className="step">
                <div className="number">4</div>
                <div className="content">
                  <h3>Concierge Support</h3>
                  <p>We take over, chasing venues and handling the back-and-forth.</p>
                </div>
              </div>

              <div className="step">
                <div className="number">5</div>
                <div className="content">
                  <h3>Confirm</h3>
                  <p>Get your booking confirmation and event-ready details delivered straight to your inbox..</p>
                </div>
              </div>

            </div>
          </div>
        </div>
        
        {/* Bottom Left SVG */}
        <div className="bottom-left-svg">
          <svg xmlns="http://www.w3.org/2000/svg" width="401" height="356" viewBox="0 0 401 356" fill="none" >
            <path fill-rule="evenodd" clip-rule="evenodd" d="M58.5 685C247.656 685 401 531.656 401 342.5C401 153.342 247.656 0 58.5 0C-130.658 0 -284 153.342 -284 342.5C-284 531.656 -130.658 685 58.5 685ZM92.6438 575.513C206.508 558.974 293.969 460.95 293.969 342.5C293.969 224.05 206.508 126.027 92.6438 109.488C82.4887 108.014 77.4094 107.276 72.1589 109.314C67.9461 110.95 63.4971 114.8 61.2708 118.735C58.5 123.638 58.5 129.519 58.5 141.281V543.719C58.5 555.48 58.5 561.361 61.2708 566.266C63.4971 570.201 67.9461 574.051 72.1589 575.688C77.4094 577.726 82.4887 576.986 92.6438 575.513Z" fill="url(#paint0_linear_330_762)"/>
            <defs>
              <linearGradient id="paint0_linear_330_762" x1="58.5" y1="685" x2="58.5" y2="0" gradientUnits="userSpaceOnUse">
                <stop offset="0.552885" stop-color="#F6C531" stop-opacity="0.15"/>
                <stop offset="1" stop-color="#046242" stop-opacity="0.15"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
      </section>
    </div>
  );
};

export default EventsInfo;
